module.exports = __webpack_public_path__ + "media/images/trash_white-04d6b81a6b47049624bcd7dc09e135af.svg";